<template>
  <div :class="[containerClass]">
    <label v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass || 'form-label fs-6 fw-bolder text-black', {isRequired: 'required'}]">
      {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
    </label>
    <vue-tel-input
        :validCharactersOnly="true"
        :inputOptions="options"
        :defaultCountry="defaultCountry"
        :dropdownOptions="dropdownOptions"
        @on-input="thirstInputChanged"
        @on-country-changed="countryChanged"
        :autoDefaultCountry="true"
        :id="`input-tel-${name}`"
        :disabled="isDisabled"
        styleClasses="form-control form-control-lg form-control-solid p-1 rounded"
        name="input-phone"
        :modelValue="telPhone"
        :autoFormat="defaultCountry !== 'tg'"
    />
  </div>
</template>

<script setup>
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

import {computed, ref, watch } from 'vue'

const props = defineProps({
  phone: String,
  phoneCode: String,
  inputClass: String,
  name: String,
  placeholder: String,
  isRequired: Boolean,
  labelClass: {type: String, default: "form-label fs-6 fw-bolder"},
  containerClass: {
    type: String,
    default: 'col-12 mb-10'
  },
  label: String,
  isDisabled: Boolean,
})

const emits = defineEmits(['update:phone', "update:phoneCode"])

const options = computed(() => {
  return {
    placeholder: props.placeholder,
    showDialCode : false,
    styleClasses: 'rounded form-control-solid',
    autocomplete: false
  }
})

const dropdownOptions = ref({
  showDialCodeInSelection: true,
  showDialCodeInList: true,
  showFlags: true
})

const defaultCountry = computed(() => {
  if (props.phoneCode) {
    const countryMap = {
      '229': 'bj',
      '228': 'tg',
      '33': 'fr',
      '1': 'us',
    }
    return countryMap[props.phoneCode.replace('+', '')] || 'bj'
  }
  return 'bj'
})

const telPhone = computed(() => props.phone?.toString())

watch(() => props.phoneCode, (val) => {
  if (val) {
    dropdownOptions.value.showFlags = false
    setTimeout(() => {
      dropdownOptions.value.showFlags = true
    }, 0)
  }
})

const countryChanged = (country) => {
  emits("update:phoneCode", '+' + country.dialCode)
}


const thirstInputChanged = (number, phoneObject) => {
  if (number && parseInt(number) && phoneObject.formatted) {
    emits("update:phone", phoneObject.formatted);
    emits("update:phoneCode", '+' + phoneObject.countryCallingCode);
  }
}

</script>

<style scoped>
input.invalid {
  border: 1px solid red;
}

div.vti__dropdown {
  padding: 0 !important;
}

</style>
